import { useEffect, useState } from 'react'
import { RetorikEvent } from '../../models/enums'

const useRetorikEvent = (instanceId?: string): RetorikEvent | undefined => {
  const [current, setCurrent] = useState<RetorikEvent | undefined>(undefined)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_retorikEvent', ((e: CustomEvent) => handleChange(e)) as EventListener)
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_retorikEvent'))

    return () => {
      document.removeEventListener('retorik_retorikEvent', ((e: CustomEvent) => handleChange(e)) as EventListener)
    }
  }, [])

  return current
}

export default useRetorikEvent
